<template>
  <div class="phrase">

    <div class="phrase__main">
      <div class="phrase__main-gradient"></div>
      <div class="phrase__main-content">
        <div class="phrase__color-phrase">
          <input ref="inputRef" class="phrase__color-input" 
            v-model="phraseText" 
            v-if="editPhrase"
            @blur="clickEndEditPhrase"
            v-on:keyup.enter="$event.target.blur()"
            />
          <div class="phrase__color-output" v-else>
            <div class="phrase__segment"
              v-for="(item, index) in actPhrase.segments"
              :key="index"
              :style="{ 'background': getSegmentColor(item) }"
              >{{item.ortho}}</div>
          </div>
        </div>
        <div class="phrase__buttons">
          <fai class="phrase__button" @click="clickEditPhrase" icon="pen" v-if="!editPhrase"></fai>
          <fai class="phrase__button" @click="clickDelPhrase" icon="ban" v-if="!editPhrase"></fai>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from '@/axios'
export default {
  data () {
    return {
        actPhrase: {
          segments: []
        },
        actParameters: [],
        editPhrase: false,
        phraseText: "",
        prevPhraseText: "",
        colors: [
          '#9EC0FF',
          '#D1FFEE',
          '#FFD6E7',
          '#E8FFF0',
          '#B5DCFF'
        ]
      }
  },
  props: {
    value: Object,
    parameters: Array,
    entities: Object,
    intentId: Number
  },
  watch: {
    value: function () {
      this.actPhrase = this.value
      this.setInputText()
      if(this.phraseText === "") this.editPhrase = true
      else this.editPhrase = false
    },
    parameters: function () {
      this.actParameters = this.parameters
    },
  },

  mounted: function () {
    if(this.value) this.actPhrase = this.value
    if(this.parameters) this.actParameters = this.parameters
    this.setInputText()
    if(this.phraseText === "") this.editPhrase = true
    else this.editPhrase = false
  },

  methods: {
    setInputText () {
      let text = ""
      for(let i = 0; i<this.actPhrase.segments.length; i++) {
        text += this.actPhrase.segments[i].ortho 
      } 
      this.phraseText = text
    },

    getSegmentColor (item) {
      if(item.parameter) {
        for(let i = 0; i<this.parameters.length; i++) {
          if(item.parameter === this.parameters[i]) {
            return this.colors[i]
          }
        }
      }
    },

    clickEditPhrase () {
      this.prevPhraseText = this.phraseText
      this.editPhrase = true
      setTimeout(() => {
        this.$refs.inputRef.focus()
      }, 0);
    },

    clickDelPhrase () {
      this.$emit('del')
    },

    async clickEndEditPhrase () {
      if(this.phraseText === "") {
        if(!this.actPhrase.id) return
        else this.phraseText = this.prevPhraseText
      } else {
        if(this.phraseText !== this.prevPhraseText) {
          // start process
          this.phraseText = this.phraseText.toLowerCase()
          let builtPhrase = await this.buildPhrase(this.phraseText)
  
          this.actPhrase.segments = builtPhrase
          //await this.segmentizeAndFindParameters(this.phraseText)
          if(this.actPhrase.id !== undefined) {
            this.actPhrase.edited = true
            for(let i = 0; i<this.actPhrase.segments.length; i++) {
              this.actPhrase.segments[i].training_phrases_id = this.actPhrase.id
            }
          }
          this.$emit('addNewTemplate')
          this.$store.commit('SET_EDITED', true)
        }
      }
      this.editPhrase = false
    },

    async buildPhrase (text) {
      // new handlers for sorted entities collection
      // to not sort original one
      const sortedRegexEntities = []
      const sortedTextEntities = []
      // copying objects references to save space
      for(let i = 0; i<this.entities.regexEntities.length; i++) {
        sortedRegexEntities.push(this.entities.regexEntities[i])
      }
      for(let i = 0; i<this.entities.textEntities.length; i++) {
        sortedTextEntities.push(this.entities.textEntities[i])
      }
      // sorting desc (first found wins)
      sortedRegexEntities.sort((a, b) => {
        return b.priority - a.priority
      })
      sortedTextEntities.sort((a, b) => {
        return b.priority - a.priority
      })
      // matched parts of texts will be excluded from segmentation
      const regexed = this.findRegexesParameters(text, sortedRegexEntities)
      const textsToSegmentize = regexed.filter(item => { if(!item.ortho) return true })
      const segmentizedTexts = await this.segmentizeTexts(textsToSegmentize)
      for(let i = 0; i<segmentizedTexts.length; i++) {
        this.findTextParameters(segmentizedTexts[i], sortedTextEntities, this.actParameters)
      }
      //this.findTextParameters(segmentizedTexts, sortedTextEntities, this.actParameters)
      let phrase = []
      for(let i = 0; i<regexed.length; i++) {
        if(regexed[i].ortho === undefined) {
          const part = segmentizedTexts.shift()
          phrase = phrase.concat(part)
        } else {
          phrase.push(regexed[i])
        }
      }
      return phrase
    },

    findRegexesParameters (text, regexEntities) {
      let final = [text]
      for(let i = 0; i<regexEntities.length; i++) {
        for(let j = 0; j<regexEntities[i].entities_regexes.length; j++) {
          let actRegex = regexEntities[i].entities_regexes[j]
          let reg = new RegExp(actRegex.exp, 'g')
          let parts = []
          for(let k = 0; k<final.length; k++) {
            if(final[k].ortho === undefined) {
              let foundOrthos = final[k].match(reg) // grabbing matched text
              if(foundOrthos === null) continue
              let splitted = final[k].split(reg)
              let segmentsToConnect = []
              for(let l = 0; l<foundOrthos.length; l++) { // inserting segment connected to regex entity
                let segment = {
                  ortho: foundOrthos[l],
                  lemma: ''
                }
                segmentsToConnect.push(segment) // connecting parameters
                splitted.splice(l+l+1, 0, segment)
              }
              this.addOrConnectParameter(segmentsToConnect, regexEntities[i], this.actParameters)
              splitted = splitted.filter(item => { if(item !== '') return true })
              let begin = final.splice(0, k)
              let end = final.splice(1)
              final = begin.concat(splitted.concat(end))
              k += splitted.length-1
            }
          }
        }
      }
      return final
    },

    findTextParameters (phraseSegments, textEntities, parameters) {
      for(let i = 0; i<textEntities.length; i++) {
        // every entry
        for(let j = 0; j<textEntities[i].entities_entries.length; j++) {
          // values (value + synonyms)
          for(let k = 0; k<textEntities[i].entities_entries[j].entries_values.length; k++) {
            let entitySegments = textEntities[i].entities_entries[j].entries_values[k].values_segments
            for(let l = 0; l<phraseSegments.length-entitySegments.length+1; l++) {
              let subPhrase = []
              for(let n = 0; n<entitySegments.length; n++) {
                subPhrase.push(phraseSegments[l+n])
              }
              // const subStates = phraseState.slice(l, l+entitySegments.length)
              // const maxPrio = -1
              // subStates.forEach(item => { if(item.priority > maxPrio) maxPrio = item.priority })
              // console.log(subStates, maxPrio)
              if(this.compareSegmentsLemma(subPhrase, entitySegments)) {
                this.addOrConnectParameter(subPhrase, textEntities[i], parameters)
              }
            }
          }
        }
      }
    },

    async segmentizeTexts (texts) {
      try {
        let segmentized = await axios.post('/api/plugin/nlp/segmentize', {
          texts: texts
        })
        return segmentized.data.segments
      } catch (e) {
        console.error(e)
      }
    },
    
    compareSegmentsLemma (subPhrase, entitySegments) {
      for(let i = 0; i<subPhrase.length; i++) {
        if(subPhrase[i].lemma !== entitySegments[i].lemma || subPhrase[i].parameter) {
          return false
        }
      }
      return true
    },

    addOrConnectParameter (segments, entity, parameters) {
      // is connection already in parameters table
      let param = null
      for(let i = 0; i<parameters.length; i++) {
        if(entity.id === parameters[i].entities_id) {
          param = parameters[i]
          break;
        }
      }
      // if not
      if(!param) {
        param = {
          name: entity.name,
          entities_id: entity.id,
          active: true
        }
        if(this.intentId !== undefined) param.intents_id = this.intentId
        parameters.push(param)
      }
      for(let i = 0; i<segments.length; i++) {
        segments[i].parameter = param
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.phrase {
  &__main {
    width: 100%;
    background-color: white;
    display: flex;
    border-radius: 0px 0px 0px 0px;
  }
  &__main-gradient {
    background-color: $primary;
    border-radius: 0px 0px 0px 0px;
    width: 4px;
    position: relative;
  }
  &__main-content {
    flex-grow: 1;
    padding: 10px 20px;
    display: flex;
    align-items: center;
  }
  &__color-phrase {
    font-size: 1.2em;
    display: flex;
    align-items: center;
    flex-grow: 1;
  }
  &__color-input {
    font-size: inherit;
    font-family: inherit;
    border: solid 0px;
    border-bottom-width: 1px;
    background: transparent;
    
    flex-grow: 1;
  }
  &__color-input:focus {
    outline-width: 0;
  }
  &__color-output {
    display: flex;
    flex-wrap: wrap;
    flex-grow: 1;
    margin-bottom: -6px;
    margin-right: 4px;
  }
  &__segment {
    margin-bottom: 6px;
    white-space: pre;
  }
  &__buttons {
    display: flex;
  }
  &__button {
    padding: 4px;
    cursor: pointer;
  }
}
</style>